import { render, staticRenderFns } from "./TemplateOrderAdd.vue?vue&type=template&id=02950547&scoped=true"
import script from "./TemplateOrderAdd.vue?vue&type=script&lang=js"
export * from "./TemplateOrderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02950547",
  null
  
)

export default component.exports